import { styled } from '@mui/material'
import { Typography, Grid, Button } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import {
  ProposalHeaderProposalFragment,
  HeaderExtraCostItemFragment
} from './ProposalHeader.generated-types'
import { formatCents } from '../../../Utilities'
import { getAddress } from '../../../Graphql-Utilities'
import { s } from './style'
import './style.less'

type OptionalExtras = Omit<HeaderExtraCostItemFragment, '__typename'>

interface ProposalHeaderProps {
  proposal: ProposalHeaderProposalFragment
}

const RightHeader = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    textAlign: 'right'
  },
}))

export const ProposalHeader: React.FC<ProposalHeaderProps> = ({
  proposal
}) => {
  const {
    currency,
    baseCostTotal,
    extraCostItems,
    space: {
      venue,
      spaceName,
    },
  } = proposal

  const [optionalExtras, setOptionalExtras] = useState<OptionalExtras[]>(null)

  useEffect(() => {
    setOptionalExtras(
      extraCostItems.map(({ ID, description, costPerUnit, quantity }) => ({
        ID,
        description,
        costPerUnit,
        quantity: quantity || 0,
      }))
    )
  }, [extraCostItems])

  const optionalExtrasTotal = _.sum(
    optionalExtras?.map(({ quantity, costPerUnit }) => quantity * costPerUnit)
  )

  const address = venue && getAddress(proposal)

  const handleScrollToLocationMap = (): void => {
    const element = document.getElementById('locationMap')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <Grid container style={s.header}>
      <Grid item xs={12} md={6}>
        <Grid>
          <Grid item xs={12}>
            <Typography style={s.spaceName} variant="h1" gutterBottom>
              {spaceName}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography style={s.venueName} variant="h2" gutterBottom>
              {venue?.name}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <RightHeader item xs={12} md={6} >
        <Grid>
          <Grid item xs={12}>
            <Typography style={s.costTotal} variant="h2" gutterBottom>
              {formatCents(currency, optionalExtrasTotal + baseCostTotal)}
              <span style={{
                fontSize: '17px',
                fontWeight: 500,
                color: '#1F1F1F',
              }}>{` (${currency === 'AUD' ? 'inc GST' : 'ex VAT'})`}</span>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography style={s.address} variant="h3" gutterBottom>
              {address}
              <Button style={{ textTransform: 'none', ...s.scollToMap }} onClick={handleScrollToLocationMap}>
                <img width={14} style={s.pinIcon} src={require('../../../Images/pin.svg')} />
                {'See map'}
              </Button>
            </Typography>
          </Grid>
        </Grid>
      </RightHeader>
    </Grid>
  )
}
